import React, { useState } from 'react';
import { 
  Share2, 
  Heart,
  Bookmark,
  Facebook, 
  Twitter, 
  Linkedin, 
  Mail
} from 'lucide-react';

const ArticleActions = () => {
  const [liked, setLiked] = useState(false);
  const [bookmarked, setBookmarked] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);

  // Fonction pour partager l'article
  const shareArticle = (platform) => {
    const url = window.location.href;
    const title = document.title;
    
    let shareUrl = '';
    
    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        break;
      case 'email':
        shareUrl = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent('Découvrez cet article : ' + url)}`;
        break;
      default:
        return;
    }
    
    window.open(shareUrl, '_blank', 'width=600,height=400');
    setShowShareMenu(false);
  };

  // Fonction pour copier le lien
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      alert('Lien copié dans le presse-papiers !');
    } catch (err) {
      console.error('Erreur lors de la copie du lien:', err);
    }
    setShowShareMenu(false);
  };

  return (
    <div className="mt-12 pt-8 border-t border-gray-200">
      {/* Actions */}
      <div className="flex items-center justify-center space-x-4 mb-6">
        <button
          onClick={() => setLiked(!liked)}
          className={`flex items-center px-4 py-2 rounded-lg transition-colors duration-200 ${
            liked 
              ? 'bg-red-500 text-white' 
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <Heart className={`w-4 h-4 mr-2 ${liked ? 'fill-current' : ''}`} />
          {liked ? 'Aimé' : 'J\'aime'}
        </button>
        
        <button
          onClick={() => setBookmarked(!bookmarked)}
          className={`flex items-center px-4 py-2 rounded-lg transition-colors duration-200 ${
            bookmarked 
              ? 'bg-yellow-500 text-white' 
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <Bookmark className={`w-4 h-4 mr-2 ${bookmarked ? 'fill-current' : ''}`} />
          {bookmarked ? 'Sauvegardé' : 'Sauvegarder'}
        </button>
        
        <div className="relative">
          <button
            onClick={() => setShowShareMenu(!showShareMenu)}
            className="flex items-center px-4 py-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg transition-colors duration-200"
          >
            <Share2 className="w-4 h-4 mr-2" />
            Partager
          </button>
          
          {showShareMenu && (
            <div className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-xl border border-gray-200 p-2 z-50">
              <button
                onClick={() => shareArticle('facebook')}
                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 rounded transition-colors duration-200"
              >
                <Facebook className="w-4 h-4 mr-3 text-blue-600" />
                Facebook
              </button>
              <button
                onClick={() => shareArticle('twitter')}
                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 rounded transition-colors duration-200"
              >
                <Twitter className="w-4 h-4 mr-3 text-blue-400" />
                Twitter
              </button>
              <button
                onClick={() => shareArticle('linkedin')}
                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 rounded transition-colors duration-200"
              >
                <Linkedin className="w-4 h-4 mr-3 text-blue-700" />
                LinkedIn
              </button>
              <button
                onClick={() => shareArticle('email')}
                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 rounded transition-colors duration-200"
              >
                <Mail className="w-4 h-4 mr-3 text-gray-600" />
                Email
              </button>
              <button
                onClick={copyLink}
                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 rounded transition-colors duration-200"
              >
                <Share2 className="w-4 h-4 mr-3 text-gray-600" />
                Copier le lien
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticleActions;